import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import { HoverBox } from '../../../hoverBox/HoverBox';
import style from './TimeOfDayBox.module.css';

export const TimeOfDayBox = ({
  startHour,
  startMinute,
  endHour,
  endMinute,
  size,
  portalRef,
}) => {
  let status;
  const now = new Date();
  const marketTime = now.toLocaleString('en-GB', {
    timeZone: 'America/New_York',
  });
  const time = marketTime.split(', ')[1];
  const [nowHour, nowMinute] = time.split(':');
  const nowInMinutes = Number(nowHour) * 60 + Number(nowMinute);
  const startMinutes = Number(startHour) * 60 + Number(startMinute);
  const endMinutes = Number(endHour) * 60 + Number(endMinute);
  if (nowInMinutes >= startMinutes && nowInMinutes <= endMinutes) status = true;
  else status = false;
  const json = {
    Category: 'Setup Filter',
    Type: 'Time of Day',
    'Start Time': startHour + ':' + startMinute,
    'End Time': endHour + ':' + `${endMinute.length > 1 ? endMinute : endMinute + '0'}`,
  };

  return (
    <>
      <foreignObject height={30} width={160} x={0} y={size - 20}>
        <div className={style.container}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Time of Day{' '}
          </Body3>
          <svg width={20} height={20}>
            <circle
              cx={10}
              cy={10}
              r={6}
              fill={status ? colors.green : colors.red}
            />
          </svg>
        </div>
      </foreignObject>
      {portalRef.current && (
        <HoverBox
          json={json}
          topBoundary={size - 20}
          bottomBoundary={size}
          leftBoundary={0}
          rightBoundary={160}
          portalRef={portalRef}
          size={size}
        />
      )}
    </>
  );
};

TimeOfDayBox.propTypes = {
  endHour: PropTypes.any,
  endMinute: PropTypes.any,
  size: PropTypes.number,
  startHour: PropTypes.any,
  startMinute: PropTypes.any,
  portalRef: PropTypes.object,
};
